import { render, staticRenderFns } from "./home-type3-content.vue?vue&type=template&id=f6144694&scoped=true"
import script from "./home-type3-content.vue?vue&type=script&lang=js"
export * from "./home-type3-content.vue?vue&type=script&lang=js"
import style0 from "./home-type3-content.vue?vue&type=style&index=0&id=f6144694&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6144694",
  null
  
)

export default component.exports